<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Pilih Chart of Account (CoA)
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Nama Kategori" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Chart of Account (CoA)
                    </div>

                    <v-autocomplete
                      v-on:keydown.enter.prevent="save()"
                      
                      filled
                      rounded
                      dense
  
                      :color="set_color"
                      placeholder="Pilih CoA"
  
                      hide-details
                      clearable
                      item-text="name"
                      item-value="id"
                      :items="item"
                      multiple
                      return-object
  
                      v-model="selected"
                      class="mb-6"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="selected !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="saveItem()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                :to="`/jurnal`"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="kominfoklaten"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Tambah Jurnal
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <v-card 
                    flat
                    class="mb-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                      <div class="fs-18 font-weight-bold black_one mb-6">
                        Informasi Jurnal
                      </div>
                      <v-row>
                        <v-col class="py-0" cols="12">

                          <div class="mb-6">
                            <div class="mb-2">
                              Ref
                            </div>
                            <div>
                              <ValidationProvider
                                :name="`Ref`" 
                                rules="required" 
                                v-slot="{ errors }">
                                <v-text-field
                                  v-on:keyup.enter="save()"
                                  
                                  rounded
                                  dense
                                  outlined
                                  hide-details
            
                                  :color="set_color"
                                  placeholder="Ref"
                                  :error-messages="errors"
            
                                  v-model="form.ref"
                                  
                                  required
                                  style="border-radius: 10px;">
                                  <template v-slot:append-outer>
                                    <div v-if="errors.length > 0">
                                      <v-tooltip top color="#ff5252">
                                        <template v-slot:activator="{ on }">
                                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                        </template>
                                        
                                        {{ errors[0] }}
                                      </v-tooltip>
                                    </div>
                                    
                                    <div v-if="form.ref !== '' && valid">
                                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                                    </div>
                                  </template>
                                </v-text-field>
                              </ValidationProvider>
                            </div>
                          </div>
                        </v-col>
                        <v-col class="py-0" cols="6">
                          <div class="mb-6">
                            <div class="mb-2">
                              Tanggal
                            </div>
                            <v-menu
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                              >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  :name="`Tanggal`" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <v-text-field
                                    v-model="form.date"
                                    
                                    v-on:keyup.enter="save()"
                                    
                                    
                                    outlined
                                    dense
                                    
                                    :color="set_color"
                                    placeholder="Tanggal "
              
                                    hide-details
                                  
              
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
                                      
                                      <div v-if="form.date !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-date-picker
                                v-model="form.date"
                                @input="menu2 = false"
                              ></v-date-picker>
                            </v-menu>
                          </div>


                          <div>
                            <div class="mb-2">
                              Waktu
                            </div>
                            <v-menu
                              v-model="menu1"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <ValidationProvider 
                                  :name="`Waktu}`" 
                                  rules="required" 
                                  v-slot="{ errors }">
                                  <v-text-field
                                    v-model="form.time"
                                    
                                    v-on:keyup.enter="save()"
                                    
                                    hide-details
                                    outlined
                                    dense
                                    
                                    :color="set_color"
                                    placeholder="Waktu"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    >
                                    <template v-slot:append-outer>
                                      <div v-if="errors.length > 0">
                                        <v-tooltip top color="#ff5252">
                                          <template v-slot:activator="{ on }">
                                            <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                          </template>
                                          
                                          {{ errors[0] }}
                                        </v-tooltip>
                                      </div>
                                      
                                      <div v-if="form.time !== '' && valid">
                                        <v-icon color="success">mdi-check-circle-outline</v-icon>
                                      </div>
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </template>
                              <v-time-picker
                                v-model="form.time"
                                format="24hr"
                                @input="menu1 = false"
                              ></v-time-picker>
                            </v-menu>

                          </div>
                        </v-col>
                        <v-col class="py-0" cols="6">
                          <div class="mb-2">
                            Catatan
                          </div>
                          <ValidationProvider
                            :name="`Catatan`" 
                            rules="required" 
                            v-slot="{ errors }">
                            <v-textarea
                              v-on:keyup.enter="save()"
                              
                              rounded
                              dense
                              outlined
                              hide-details
        
                              :color="set_color"
                              placeholder="Catatan"
                              :error-messages="errors"
        
                              v-model="form.note"
                              
                              required
                              style="border-radius: 10px;">
                              <template v-slot:append-outer>
                                <div v-if="errors.length > 0">
                                  <v-tooltip top color="#ff5252">
                                    <template v-slot:activator="{ on }">
                                      <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                    </template>
                                    
                                    {{ errors[0] }}
                                  </v-tooltip>
                                </div>
                                
                                <div v-if="form.note !== '' && valid">
                                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                                </div>
                              </template>
                            </v-textarea>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <v-card 
                    flat
                    min-height="calc(100vh - 245px)"
                    style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                    <v-card-text>
                          <v-row>
                            <v-col>
                              <div class="d-flex px-2" style="width: 100%;">
                                <div class="fs-18 font-weight-bold black_one">
                                  Data Chart of Account (CoA)
                                </div>
      
                                <div class="ml-auto">
                                  <v-btn
                                    elevation="0"
                                    @click="dialog.form = true; reset();"
                                    color="#240087"
                                    class="fs-12 white--text text-capitalize border-radius">
                                    <v-icon
                                      size="20">
                                      mdi-plus
                                    </v-icon>
      
                                    <span
                                      class="ml-2">
                                      Tambah 
                                    </span>
                                  </v-btn>
                                </div>
                              </div>

                              <v-card flat
                                v-if="form.items.length < 1">
                                <v-card-text
                                  class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                                  <div class="text-center">
                                    <v-img 
                                      class="mx-auto"
                                      contain
                                      alt="vuetify"
                                      :width="90"
                                      :height="90"
                                      :src="require('@/assets/image/empty.png')">
                                      <!-- <template v-slot:placeholder>
                                        <v-row
                                          class=" "
                                          align="center"
                                          justify="center">
                                          <v-progress-circular 
                                            indeterminate 
                                            :color="set_color">
                                          </v-progress-circular>
                                        </v-row>
                                      </template> -->
                                    </v-img>
                                    <div class="mt-3 fs-18">
                                      Belum Ada Data
                                    </div>
                                  </div>
                                </v-card-text>
                              </v-card>

                              <div class="mt-5" v-if="form.items.length > 0">
                                <div v-for="(item, index) in form.items" :key="index">
                                  <v-card flat class="mb-5" style="    background: #f0f8ff80; border-radius: 10px; border: 1px solid #f1f1f1;">
                                    <v-card-text>
                                      <div class="d-flex">
                                        <div>
                                          <div class="fs-16 font-weight-bold black_one">
                                            {{ item.name }}
                                          </div>
                                        </div>

                                        <div class="ml-auto text-right">
                                          <v-tooltip 
                                            top>
                                            <template v-slot:activator="{ on, attrs }">
                                              <v-btn
                                              
                                                @click="form.items.splice(index, 1);"

                                                v-bind="attrs"
                                                v-on="on"

                                                min-width="28"
                                                small
                                                rounded
                                                color="red"
                                                elevation="0"
                                                class="white--text text-capitalize mx-1 px-0 mb-2"
                                                style="font-weight: 600; border-radius: 6px;">
                                                <v-icon small>mdi-trash-can-outline</v-icon>
                                              </v-btn>
                                            </template>
                                            
                                            <span>Hapus</span>
                                          </v-tooltip>

                                          
                                        </div>
                                        
                                      </div>

                                      <v-row class="mt-0">
                                        <v-col cols="6">
                                          <div>
                                            Debit
                                          </div>
                                        </v-col>
                                        <v-col cols="6">
                                          <div>
                                            Kredit
                                          </div>
                                        </v-col>
                                        <!-- <v-col cols="4" class="text-left">
                                          <div>
                                            Ref
                                          </div>
                                        </v-col> -->

                                        <v-col class="py-0" cols="6">
                                          <div>
                                            <ValidationProvider
                                              :name="`Debit ${item.name}`" 
                                              :rules="`min_value:0`" 
                                              v-slot="{ errors }">
                                              <v-currency-field
                                                    
                                                
                                                rounded
                                                dense
                                                outlined
                                                hide-details
                          
                                                :color="set_color"
                                                placeholder="Debit"
                                                :error-messages="errors"

                                                
                          
                                                v-model="item.debit"
                                                
                                                required
                                                style="border-radius: 10px;">
                                                <template v-slot:append-outer>
                                                  <div v-if="errors.length > 0">
                                                    <v-tooltip top color="#ff5252">
                                                      <template v-slot:activator="{ on }">
                                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                      </template>
                                                      
                                                      {{ errors[0] }}
                                                    </v-tooltip>
                                                  </div>
                                                  
                                                  <div v-if="item.debit !== '' && valid">
                                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                                  </div>
                                                </template>
                                              </v-currency-field>
                                            </ValidationProvider>
                                          </div>
                                        </v-col>
                                        <v-col class="py-0" cols="6">
                                          <div>
                                            <ValidationProvider
                                              :name="`Kredit ${item.name}`" 
                                              :rules="`min_value:0`" 
                                              v-slot="{ errors }">
                                              <v-currency-field
                                                    
                                                
                                                rounded
                                                dense
                                                outlined
                                                hide-details
                          
                                                :color="set_color"
                                                placeholder="Kredit"
                                                :error-messages="errors"

                                                
                          
                                                v-model="item.kredit"
                                                
                                                required
                                                style="border-radius: 10px;">
                                                <template v-slot:append-outer>
                                                  <div v-if="errors.length > 0">
                                                    <v-tooltip top color="#ff5252">
                                                      <template v-slot:activator="{ on }">
                                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                      </template>
                                                      
                                                      {{ errors[0] }}
                                                    </v-tooltip>
                                                  </div>
                                                  
                                                  <div v-if="item.kredit !== '' && valid">
                                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                                  </div>
                                                </template>
                                              </v-currency-field>
                                            </ValidationProvider>
                                          </div>
                                        </v-col>
                                        <!-- <v-col cols="4" class="py-0 text-right">
                                          <div>
                                            <ValidationProvider
                                              :name="`Ref ${item.name}`" 
                                              rules="required" 
                                              v-slot="{ errors }">
                                              <v-text-field
                                                v-on:keyup.enter="save()"
                                                
                                                rounded
                                                dense
                                                outlined
                                                hide-details
                          
                                                :color="set_color"
                                                placeholder="Ref"
                                                :error-messages="errors"
                          
                                                v-model="item.ref"
                                                
                                                required
                                                style="border-radius: 10px;">
                                                <template v-slot:append-outer>
                                                  <div v-if="errors.length > 0">
                                                    <v-tooltip top color="#ff5252">
                                                      <template v-slot:activator="{ on }">
                                                        <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                                      </template>
                                                      
                                                      {{ errors[0] }}
                                                    </v-tooltip>
                                                  </div>
                                                  
                                                  <div v-if="item.ref !== '' && valid">
                                                    <v-icon color="success">mdi-check-circle-outline</v-icon>
                                                  </div>
                                                </template>
                                              </v-text-field>
                                            </ValidationProvider>
                                          </div>
                                        </v-col> -->
                                      </v-row>
                                    </v-card-text>
                                  </v-card>
                                </div>
                                <!-- <v-divider class="my-2"></v-divider>
                                <v-row>
                                  <v-col>
                                    <div class="fs-17 font_weight_600 text-left black_one">
                                      Total Perkiraan Modal Belanja
                                    </div>
                                  </v-col>
                                  <v-col>
                                    <div class="fs-17 font_weight_600 text-right black_one">
                                      {{ total_nominal | price }}
                                    </div>
                                  </v-col>
                                </v-row> -->
                              </div>

                            </v-col>
                          </v-row>

                          
                          <div v-if="message.error.length > 0"
                            class="text-center my-4 d-flex align-center">
                            <div
                            class="error--text">
                            <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                            
                            <span
                            class="ml-1">
                            {{ message.error }}
                          </span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-form>
              </ValidationObserver>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="d-flex align-center justify-end py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form || form.items.length < 1"
                elevation="0"
                color="#240087"
                class="fs-16 white--text text-capitalize border-radius">
                <v-icon
                  size="20">
                  mdi-checkbox-marked-circle-outline
                </v-icon>

                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
              
              <v-btn
                :to="`/jurnal`"
                :disabled="process.form"
                color="red"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center ml-4"
                style="border-radius: 10px; font-weight: 600;">
                <v-icon 
                  size="20">
                  mdi-progress-close
                </v-icon>

                <span
                  class="ml-2">
                  Batal
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        item: [],

        dialog: {
          form: false,
          fullscreen: false
        
        },
        menu: {
          
        },
        modalTime: {
          
        },
        total_nominal: 0,

        form: {
          outlet_id: '',
          location_id: '',

          date: '',
          status: '',
          items: [],
          note: '',
          datetime: '',
          ref: '',
          date: '',
          time: '',

        },
        detail: {
          number: '',
          date: '',
          status: ''
        },
        detail_item: [],
        selected: [],
        menu2: false,
        menu1: false,
        location: [],
        show: false,
        upload: {
          image: null
        },

        process: {
          form: false,
          load: false,

          image: false
        },
        
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch (data) {
        let params = {
          limit: 100000,
          year: moment().format('YYYY')
        }
        
        await get('coa_master/data_last_child', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.item = []
            res.results.data.map((item) => {
              this.item.push({ 
                ...item,
                debit: 0,
                kredit: 0,
                note: '',
                datetime: '',
                ref: '',
                date: '',
                time: '',
                coa_id: item.id
              })
            })

            this.menu = res.results.data.map(item => {
              return {
                menu: false
              }
            })

            this.modalTime = res.results.data.map((item, index) => {
              return {
                menu: false,
                reft: `time${index}`
              }
            })
          }
        })
      },
      changeTotal() {
        this.total_nominal = this.form.items.reduce((acc, item) => {
          return acc + (item.qty * item.purchase_price)
        }, 0)
      },
      changeHarga(index) {
        this.form.items[index].supplier.map((supplier) => {
          if(supplier.supplier_id === this.form.items[index].supplier_id) {
            this.form.items[index].purchase_price = supplier.purchase_price
            this.changeTotal()
          }
        })
      },

      reset () {
        this.selected = this.form.items
      },
      saveItem () {
        this.form.items = this.selected
        this.dialog.form = false
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`jurnal/add`, {
            data: {
              jurnal_arr: JSON.stringify(this.form.items.map(item => {
              return {
                coa_id: item.id,
                debit: item.debit,
                kredit: item.kredit,
                ref: this.form.ref,
                datetime: `${this.form.date} ${this.form.time}`,
                note: this.form.note
              }
            }))
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.$router.push({ path: `/jurnal` })

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>